// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"66beea17","538":"750314a4","545":"1c55158c","688":"69720d8a","767":"79b11725","776":"9ba6fdb0","825":"f3576aff"}[chunkId] + ".chunk.js";
};